import { Watchlist, Tag as WorkspaceTag } from '@/types';

export type PrimitiveKind = 'tags' | 'watchlists';
export type PrimitiveRecord = WorkspaceTag | Watchlist;

export const isWorkspaceTag = (record: PrimitiveRecord | undefined): record is WorkspaceTag =>
    Boolean(record && 'assignmentCount' in record);
